import { render, staticRenderFns } from "./PortalAppPlain.vue?vue&type=template&id=66c0747a&lang=pug"
import script from "./PortalAppPlain.vue?vue&type=script&lang=js"
export * from "./PortalAppPlain.vue?vue&type=script&lang=js"
import style0 from "./PortalAppPlain.vue?vue&type=style&index=0&id=66c0747a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports